<template>
  <div class="login-container">
    <!-- <input type="button" name="" value="登录" @click="submitForm()"> -->
    <img class="logo" src="static/img/verifone_logo_1.png" />

    <div class="international">
      <img class="country-img" :src="countryImg" />

      <el-select class="international-select" v-model="selectedCountry" @change="changeInternational" placeholder="">
        <el-option v-for="item in options" :key="item.value" :label="item.valueKey" :value="item.value">
          <img class="option-img" :src="item.label" />
          <span>&nbsp;{{ item.valueKey }}</span>
        </el-option>
      </el-select>
    </div>

    <div class="login-bg" :style="loginBg"></div>

    <div class="login-panel">
      <div class="login-panel-main">
        <div class="title-container">
          <span class="preTitle">{{ $t('message.loginTitle') }}</span>
          <span class="verifoneTitle">{{ $t('message.titleEnd') }}</span>
        </div>
        <div class="username-container">
          <el-input class="login-item" v-model="username" :placeholder="$t('message.usernameLogin')"   maxlength="50" @keyup.enter.native="submitForm"></el-input>
          <img class="item-icon" src="static/img/user.png" />
        </div>
        <div class="password-container">
          <el-input class="login-item" type="password" v-model="password" :placeholder="$t('message.passwordLogin')" maxlength="16" @keyup.enter.native="submitForm"></el-input>
          <img class="item-icon" src="static/img/password.png" />
        </div>
        <div class="select-container " id="selectReseller" >
          <template>
            <el-select v-model="id" class="login-item el-input" clearable  @click.native="getResellerList()"   @change="handleChange" :placeholder="$t('message.selectTip')">
              <el-option v-for="item in resellerList" :key="item.resellerName" :label="item.resellerName" :value="item.id"></el-option>
            </el-select>
             <img class="item-icon" src="static/img/selectReseller.png" />
          </template>
        </div>
        <div class="code-container login-item">
          <div class="code-input-container">
            <el-input v-model="code" :placeholder="$t('message.verification')" maxlength="4" @keyup.enter.native="submitForm"  @focus="blurPrice()"></el-input>
            <img class="item-icon verify-img" src="static/img/verify.png" />
          </div>
          <img class="code-img" ref="codeImg" :src="imgSrc" @click="queryVerifyCode" @keyup.enter.native="submitForm" />
        </div>

        <div class="remember-container">
          <div class="remember-main">
            <input class="rememberCheckbox" type="checkbox" name="" v-model="rememberChecked" />
            <span>{{ $t('message.rememberPassword') }}</span>
            <!-- <el-checkbox v-model="rememberChecked">{{$t('message.rememberPassword')}}</el-checkbox> -->
          </div>
          <div class="forget-main">
            <!-- <el-popover
                        placement="right-start"
                        :title="$t('message.callTitle')"
                        width="200"
                        trigger="click"
                        content="0369-8521496"> -->
            <!-- <el-button slot="reference">{{$t('message.version')}}:{{version}}</el-button> -->
            <span slot="reference">{{ $t('message.version') }}:{{ version }}</span>
            <!-- </el-popover> -->
          </div>
        </div>

        <el-button class="login-btn" @click="submitForm" @keyup.enter.native="submitForm">{{ $t('message.login') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['reload'],
  data() {
    return {
      rememberChecked: false,
      username: '',
      password: '',
      code: '',
      imgSrc: '',
      version: '',
      token: '',
      role: null,
      loginFlag: false,
      selectedCountry: 0,
      alertValue: 99,
      resellerName: '',
      id: '',
      resellerList: [],
      loginBg: { backgroundImage: "url('static/img/login_bg.jpg')" },
      loginSuccess: this.$t('message.loginSuccess'),
      inputCheck: this.$t('message.inputCheck'),
      veryCheck: this.$t('message.veryCheck'),
      userNameCheck: this.$t('message.userNameCheck'),
      passWordCheck: this.$t('message.passWordCheck'),
      userNameLength: this.$t('message.userNameLength'),
      passWordLength: this.$t('message.passWordLength'),
      resellerNameCheck: this.$t('message.resellerNameCheck'),
      /*  passwordChecked: this.$('message.passwordChecked'),*/
      countryImg: 'static/img/UK.png',
      options: [
        {
          value: 0,
          label: 'static/img/UK.png',
          valueKey: 'English'
        },
        {
          value: 1,
          label: 'static/img/China.png',
          valueKey: '中文'
        }
      ]
    };
  },
  mounted() {
    this.setLanguage();
    this.queryVerifyCode();
    this.setRemember();
    this.queryVersion();
  },
  /**
   * 监听用户名和密码的长度
   */
  watch: {
    username: function(val) {
      if (val.length > 50) {
        this.$message({
          type: 'error',
          message: this.userNameLength,
          duration: '3000'
        });
        return;
      }
    },
    password: function(val) {
      if (val.length > 16) {
        this.$message({
          type: 'error',
          message: this.passWordLength,
          duration: '3000'
        });
        return;
      }
    }
  },

  methods: {
    setRemember() {
      let localName = localStorage.getItem('lailrApplicationName');
      let localPassword = localStorage.getItem('lailrApplicationPassword');

      if (localName) {
        this.username = localName;
        this.password = localPassword;
        this.rememberChecked = true;
      }
    },
    setEnglish() {
      this.selectedCountry = 0;
      this.countryImg = 'static/img/UK.png';
      this.$i18n.locale = 'en';
      sessionStorage.setItem('acceptLanguage', 'en-US, en');
    },
    setChinese() {
      this.selectedCountry = 1;
      this.countryImg = 'static/img/China.png';
      this.$i18n.locale = 'cn';
      sessionStorage.setItem('acceptLanguage', 'zh-CN, zh');
    },
    setLanguage() {
      let languageDefault = sessionStorage.getItem('defaultLanguage');
      if (languageDefault == 'en') {
        this.setEnglish();
      } else if (languageDefault == 'cn') {
        this.setChinese();
      } else {
        this.getDefaultLanguage();
      }
    },
    // 去后台获取默认语言
    getDefaultLanguage() {
      this.$axios({
        method: 'post',
        url: '/marketplace/defaultLanguage',
        async: false
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            sessionStorage.setItem('defaultLanguage', response.data.defaultLanguage);
            if (response.data.defaultLanguage == 'en') {
              this.setEnglish();
            } else if (response.data.defaultLanguage == 'cn') {
              this.setChinese();
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    changeInternational(item) {
      if (item == 0) {
        this.countryImg = 'static/img/UK.png';
        this.$i18n.locale = 'en';
        sessionStorage.setItem('defaultLanguage', 'en');
        sessionStorage.setItem('acceptLanguage', 'en-US, en');
      } else {
        this.countryImg = 'static/img/China.png';
        this.$i18n.locale = 'cn';
        sessionStorage.setItem('defaultLanguage', 'cn');
        sessionStorage.setItem('acceptLanguage', 'zh-CN, zh');
      }

      this.reload();
    },
    queryVersion() {
      this.$axios({
        method: 'post',
        url: '/marketplace/version',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') }
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            this.version = response.data.version;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    queryVerifyCode() {
      let that = this;
      this.$axios({
        method: 'get',
        url: '/marketplace/verifycode',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') }
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            that.imgSrc = response.data.image;
            that.token = response.data.token;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitForm() {
      let that = this;
      if (this.username == '') {
        this.$message({
          type: 'error',
          message: this.$i18n.t('message.userNameCheck'),
          duration: '3000'
        });
        return;
      }
      if (this.password == '') {
        this.$message({
          type: 'error',
          message: this.$i18n.t('message.passWordCheck'),
          duration: '3000'
        });
        return;
      }
      /*  if(this.password.length<8){
               this.message({
                 type:"error",
                 message:this.passwordChecked,
                 duration:'3000',
               });
               return;

            }*/
      if (this.id == '') {
        this.$message({
          type: 'error',
          message: this.resellerNameCheck,
          duration: '3000'
        });
        return;
      }
      if (this.code == '') {
        this.$message({
          type: 'error',
          message: this.veryCheck,
          duration: '3000'
        });
        return;
      }
      /* 记住密码，设置缓存*/
      if (this.rememberChecked) {
        localStorage.setItem('lailrApplicationName', this.username);
        localStorage.setItem('lailrApplicationPassword', this.password);
      } else {
        localStorage.removeItem('lailrApplicationName');
        localStorage.removeItem('lailrApplicationPassword');
      }

      let obj = {
        username: this.username,
        password: this.password,
        token: this.token,
        code: this.code,
        resellerId: this.id
      };

      this.$axios({
        method: 'post',
        url: '/marketplace/login',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            sessionStorage.setItem('verifoneLoginFlag', true);
            sessionStorage.setItem('verifoneRoleList', response.data.roleList);
            sessionStorage.setItem('verifoneUsername', response.data.username);
            sessionStorage.setItem('verifoneResellerName', response.data.resellerName);
            sessionStorage.setItem("googleMapKey", response.data.googleMapKey);
            sessionStorage.setItem("qqMapKey", response.data.qqMapKey);

            setTimeout(function() {
              that.$message({
                type: 'success',
                message: that.loginSuccess,
                duration: '1000'
              });
            }, 100);

            this.$router.replace('/home');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleChange(val) {
      var obj = {};
      console.log(this.resellerList)
      obj = this.resellerList.find(function(item) {
        return item.resellerName === val;
      });
        console.log(val);
       this.id = val;
    },
    //记住密码时触发该方法
    getResellerList() {
   this.resellerList ='';
   if(this.username == ''){
    this.$message({
      type: 'error',
      message: this.userNameCheck,
      duration: '3000'
    });
    return;
   }else{
     let obj = {
       username: this.username
     };

     this.$axios({
       method: 'post',
       url: '/marketplace/findResellerList',
       headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
       data: obj
     })
       .then(response => {
         if (response.data.code != '00') {
           this.$message({
             type: 'error',
             message: response.data.desc,
             duration: '3000'
           });
           return;
         } else {
           this.resellerList = response.data.data;
           //只有一个运营商时默认赋值当前运营商到选择框上面


         }
       })
       .catch(err => {
         console.log(err);
       });
   }
    } ,
        //验证码获得焦点
        blurPrice:function(){
          //清空当前运营商集合
           this.resellerList ='';
          if(this.username == ''){
           this.$message({
             type: 'error',
             message: this.userNameCheck,
             duration: '3000'
           });
           return;
          }else{
            if(this.id==""){
              let obj = {
                username: this.username
              };

              this.$axios({
                method: 'post',
                url: '/marketplace/findResellerList',
                headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
                data: obj
              })
                .then(response => {
                  if (response.data.code != '00') {
                    this.$message({
                      type: 'error',
                      message: response.data.desc,
                      duration: '3000'
                    });
                    return;
                  } else {
                    this.resellerList = response.data.data;
                    //当只有一个值设置默认
                    if(response.data.data.length==1){
                      console.log(response.data.data.length)
                      console.log(this.id)
                      console.log(this.resellerName)
                      //先清空一次当前的值，在重新设置值进去
                      this.id="";
                      this.resellerName ="";
                      this.resellerName=this.resellerList[0].resellerName;
                      this.id = this.resellerList[0].id;
                    }
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }else{

            }

          }
    }

  }
};
</script>
<style scope>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.login-container {
  width: 100vw;
  height: 100vh;
  /* background-color: #E0EAF4; */
  overflow: hidden;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}
.code-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
}
.logo {
  width: 150px;
  height: auto;
  position: absolute;
  top: 25px;
  left: 25px;
}
.login-panel {
  position: absolute;
  right: 20vw;
}
.login-panel-main {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  width: 450px;
  padding: 30px 60px 40px 60px;
  background-color: #fff;
  border-radius: 20px;
  border: 1px solid #ddd;
}
.login-panel-main h2 {
  color: #999;
  font-family: 'Arial';
  width: 100%;
  margin-bottom: 20px;
  font-weight: 400;
}
.code-img {
  width: 100px;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
}
.login-item {
  margin-bottom: 28px;
}
.item-icon {
  width: 22px;
  height: 21px;
  position: absolute;
  top: 12px;
  left: 10px;
}
.username-container,
.password-container,
.code-container,
.select-container {
  position: relative;
}
.login-panel-main input {
  padding-left: 40px;
  background-color: #fff;
}
.login-btn {
  background-color: #3e6eba !important;
  color: #fff !important;
  border: 1px solid #6590dc;
  width: 45%;
  margin: 20px 0 0 180px;
  right: 0px;
}
.international-select {
  width: 160px;
}
.international {
  position: absolute;
  right: 40px;
  top: 15px;
}
.option-img {
  width: 40px;
  height: 40px;
}
.country-img {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 2px;
  left: -50px;
}
.el-select-dropdown__item {
  display: flex;
  display: -webkit-display;
}
.login-bg {
  width: 100%;
  height: 40vh;
}
.login-panel .el-input__inner {
  height: 46px;
  border-radius: 10px;
}
.international .el-input__inner,
.international .el-input__inner:hover,
.international .el-input__inner:focus {
  border: 1px solid #fff;
}
.remember-container {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}
.remember-main {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.forget-main .el-button {
  border: 1px solid #fff;
  padding: 0;
}
.rememberCheckbox {
  margin-right: 3px;
}
.title-container {
  margin-bottom: 20px;
  color: #999;
  font-size: 22px;
  font-family: 'Arial';
}
.verifoneTitle {
  font-weight: 600;
  color: #666;
}
.selectReseller {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Login.vue